export default "__VITE_ASSET__B8VPzdM4__"